import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { queryClient } from 'src/app/queryClient';
import { getSelectedColumns, updateSelectedColumns } from './api';
import { EventServicePageNameTypes } from './apiTypes';

const selectedColumnsApiKey = (pageName: EventServicePageNameTypes) => [`selected-columns-for-${pageName}`];

export const useGetSelectedColumnsQuery = (payload: { userId: number; pageName: EventServicePageNameTypes }, options?: Omit<UseQueryOptions<any>, 'queryKey' | 'queryFn'>) =>
    useQuery(selectedColumnsApiKey(payload.pageName), () => getSelectedColumns(payload), options);

export const useUpdateSelectedColumnsMutation = () =>
    useMutation(updateSelectedColumns, {
        onSuccess: (_, variables) => {
            invalidateUseGetSelectedColumnsQuery(variables.pageName);
        }
    });
export const invalidateUseGetSelectedColumnsQuery = (pageName: EventServicePageNameTypes) => {
    queryClient.invalidateQueries(selectedColumnsApiKey(pageName));
};
